import { useNavigate, useParams } from "react-router-dom";

import { useViewReturnRequestProductsColumns } from "./ViewReturnRequestproductsColumns";

import FetchWrapper from "@/components/reusables/FetchWrapper";
import CustomHeader from "@/components/reusables/Headers.tsx";
import { CustomTable } from "@/components/reusables/data-table/CustomTable";
import { ROUTES } from "@/constants/routes_sidebar/routes-constant";
import { ToolsConstants } from "@/constants/tools.constant";
import DataTableSlotContextProvider from "@/context/DataTableSlot";
import { useGetParams } from "@/hooks/useGetParams";
import { IReturnRequest } from "@/interfaces/tools.interface";
import { useGetReturnRequestQuery } from "@/redux/api/toolsQuery";

const ViewReturnRequestProducts = (): JSX.Element => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const filters = useGetParams(["search"]);

  const { data, ...rest } = useGetReturnRequestQuery(
    {
      id,
      filters,
    },
    {
      skip: !id,
    },
  );

  const singleReturnReqData = data?.data as IReturnRequest;

  const projectSiteAssigned = singleReturnReqData?.project.address.label;
  const columns = useViewReturnRequestProductsColumns({
    site: projectSiteAssigned ?? "",
  });

  return (
    <DataTableSlotContextProvider>
      <CustomHeader
        title={ToolsConstants.INDEX_CONTENT_TEXT.PRODUCT_HEADER}
        backBtn={() => {
          navigate(ROUTES.TOOLS + ROUTES.REQUEST);
        }}
      />
      <FetchWrapper {...rest} isTable>
        <CustomTable
          title={ToolsConstants.INDEX_CONTENT_TEXT.PRODUCT_HEADER}
          columns={columns}
          data={singleReturnReqData?.returnItems ?? []}
          empty={{}}
          hide={{
            filters: true,
            functions: true,
          }}
          functions={{
            search: ToolsConstants.INDEX_CONTENT_TEXT.PRODUCT_HEADER,
            isExport: true,
            columnToggle: true,
          }}
        />
      </FetchWrapper>
    </DataTableSlotContextProvider>
  );
};

export default ViewReturnRequestProducts;
